import { capitalizeFirstLetter } from 'utils'

const PB_TYPES = {
  chat: 'CHAT',
  email: 'EMAIL',
  fastlane: 'FASTLANE',
  sequence: 'MARKETING_SEQUENCE',
  meetings: 'MEETING_BOOKING_BOT',
}

export const getMenuOptions = (
  pathNames,
  hasAnyPlaybookAccess,
  history,
  toggleMarketplace,
  setSelectedPlaybookType
) => {
  return pathNames.flatMap((pathName) => {
    if (pathName === 'CHAT') {
      return [
        {
          name: 'Bot / live chat',
          action: () => {
            setSelectedPlaybookType('CHAT')
            toggleMarketplace()
          },
        },
        {
          name: 'Landing page',
          action: () => {
            setSelectedPlaybookType('CLP')
            toggleMarketplace()
          },
        },
      ]
    }

    return [
      {
        name: hasAnyPlaybookAccess
          ? capitalizeFirstLetter(pathName.toLowerCase())
          : 'Create sequence',
        action: () => {
          pathName === PB_TYPES.fastlane
            ? history.push('/list/fastlane/create')
            : setSelectedPlaybookType(
                PB_TYPES[pathName.toLowerCase()] || 'CHAT'
              )
          toggleMarketplace()
        },
      },
    ]
  })
}
